import * as _ from 'lodash-es';

export default function setSiteConfig(siteConfig: any, $window: Window) {
    _.defaults($window, siteConfig);
}
